/** @jsxImportSource @emotion/react */
import tapCardImg from '../../../../assets/images/tapCard.svg';
import * as React from 'react';
import { Column, Row } from '../../../../layout/flexbox';
import * as Buttons from '../../../../forms/elements/buttons';
import { css } from '@emotion/react';
import * as R from 'ramda';
import { BoxedErrorInverse } from '../../../../forms/elements/boxedMessage/boxedMessageStyles';
import { StyledBoxedMessage } from '../../../../forms/elements/boxedMessage/StyledBoxedMessage';
import { Input } from '../../../../forms/elements/Input';
import { COLUMN_SPACING, ROW_SPACING } from '../../../../forms/styles';
import LabeledData from '../../../../forms/elements/LabeledData';
import ErrorView from '../../../../forms/ErrorView';
import { getResource } from '../../../../language/resources/getResource';

const rfidInputLabel = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const rfidInputImage = css`
  width:63px;
  height: 40px;
  flex-basis: 63px;
  margin-right: 10px;
`
const rfidInput = css`
  min-width: 350px;
  vertical-align: bottom;
  flex-grow: 1;
`

/**
 * RfidChipIdForm: a component that renders a form for taking in the chip ID upon pass scan
 * to associate with guest's pass and connects UI for submission.  This component validates on
 * the RFID number being anything besides 20 characters and on the existence of a duplicate in a household.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class RfidChipIdForm extends React.PureComponent<{
  onChipIdUpdate: (code: string) => void,
  onSubmit: () => void,
  onClose: () => void,
  error?: string,
  chipId: string,
  passIsLinked: boolean,
  passIsLinkedMsg: string,
  guestName: string,
  resources: Record<string, any>,
}> {
  public static defaultProps = {
    error:  '',
    chipId: '',
  };

  private onIdUpdate = event => this.props.onChipIdUpdate((R.path<string>([ 'target', 'value' ], event) || '').trim());

  public render = () => (
    <Column alignItems='stretch' rootCss={COLUMN_SPACING}>
      {/* Guest Name */}
      <LabeledData label={getResource(this.props.resources, 'RFID_FORM_LABEL')} data={this.props.guestName} title={getResource(this.props.resources, 'RFID_FORM_TITLE', this.props.guestName)}/>

      { // Pass is already linked message
        this.props.passIsLinked && <StyledBoxedMessage extraCss={css`margin-bottom: 25px;`}
                                                       message={this.props.passIsLinkedMsg}
                                                       boxStyle={BoxedErrorInverse}/>
      }

      { // RFID Code Input
        !this.props.passIsLinked && <label css={rfidInputLabel}>
          <img src={tapCardImg}
               alt="Read pass's chip number"
               css={rfidInputImage}/>
          <Input id='rfidChipId'
                 autoFocus={true}
                 title={getResource(this.props.resources, 'GUEST_LINK_RFID_INPUT_TITLE')}
                 placeholder={getResource(this.props.resources, 'GUEST_LINK_RFID_INPUT_PLACEHOLDER')}
                 value={this.props.chipId}
                 onChange={this.onIdUpdate}
                 type='text'
                 css={rfidInput}/>
        </label>
      }

      {/* Validation Errors */}
      <ErrorView error={this.props.error}/>

      {/* Submit/Cancel buttons */}
      <Row justifyContent='flex-end' rootCss={ROW_SPACING}>
        {
          this.props.passIsLinked
          ? <Buttons.BigNeutral type="button"
                                onClick={this.props.onClose}
                                title={getResource(this.props.resources, 'RFID_FORM_RETURN')}>{getResource(this.props.resources, 'RFID_FORM_OKAY')}</Buttons.BigNeutral>
          : <React.Fragment>
            <Buttons.BigSecondary type="button"
                                  onClick={this.props.onClose}
                                  title={getResource(this.props.resources, 'RFID_FORM_CANCEL_RFID_LINKING')}>{getResource(this.props.resources, 'RFID_FORM_CANCEL')}</Buttons.BigSecondary>
            <Buttons.BigNeutral type="submit"
                                onClick={this.props.onSubmit}
                                title={getResource(this.props.resources, 'RFID_FORM_SUBMIT_RFID')}>{getResource(this.props.resources, 'RFID_FORM_SUBMIT')}</Buttons.BigNeutral>
          </React.Fragment>
        }
      </Row>
    </Column>
  );
}
